import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  resend(id) {
    return axios.post(`${this.url}/${id}/resend`);
  }
}

export default new CampaignsAPI();
